export const supportedLocales = [
  "en",
  "es",
  "fr",
  "de",
  "pt",
  "zh-Hans",
  "ja",
  "ko",
  "ar",
  "hi",
  "ms"
] as const;

export type SupportedLocale = (typeof supportedLocales)[number];
export type LocaleDirection = "ltr" | "rtl";

export type LocaleMeta = {
  code: SupportedLocale;
  label: string;
  nativeLabel: string;
  dir: LocaleDirection;
};

export const localeMeta: Record<SupportedLocale, LocaleMeta> = {
  en: { code: "en", label: "English", nativeLabel: "English", dir: "ltr" },
  es: { code: "es", label: "Spanish", nativeLabel: "Español", dir: "ltr" },
  fr: { code: "fr", label: "French", nativeLabel: "Français", dir: "ltr" },
  de: { code: "de", label: "German", nativeLabel: "Deutsch", dir: "ltr" },
  pt: { code: "pt", label: "Portuguese", nativeLabel: "Português", dir: "ltr" },
  "zh-Hans": { code: "zh-Hans", label: "Chinese", nativeLabel: "简体中文", dir: "ltr" },
  ja: { code: "ja", label: "Japanese", nativeLabel: "日本語", dir: "ltr" },
  ko: { code: "ko", label: "Korean", nativeLabel: "한국어", dir: "ltr" },
  ar: { code: "ar", label: "Arabic", nativeLabel: "العربية", dir: "rtl" },
  hi: { code: "hi", label: "Hindi", nativeLabel: "हिन्दी", dir: "ltr" },
  ms: { code: "ms", label: "Malay", nativeLabel: "Bahasa Melayu", dir: "ltr" }
};

export const defaultLocale = "en" satisfies SupportedLocale;

export function supportedLocaleFor(locale: string | null | undefined): SupportedLocale {
  const normalized = locale?.trim();
  if (!normalized) return defaultLocale;

  const direct = supportedLocales.find(
    (candidate) => candidate.toLowerCase() === normalized.toLowerCase()
  );
  if (direct) return direct;

  const language = normalized.split("-")[0]?.toLowerCase();
  if (language === "zh") return "zh-Hans";

  const languageMatch = supportedLocales.find((candidate) => candidate === language);
  return languageMatch ?? defaultLocale;
}
